import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { SortOption } from 'src/app/core/models/filter.model';
import { FilterService } from 'src/app/core/services/filter.service';

@Component({
  selector: 'app-car-sort',
  templateUrl: './car-sort.component.html',
  styleUrls: ['./car-sort.component.scss',],
})
export class CarSortComponent implements OnInit {

  faSort = faSort;
  isOpen: boolean = false;
  sortByLabel: string = '';
  sortOptions: SortOption[] = [];

  constructor(
    private _filterService: FilterService,
    private _activateRoute: ActivatedRoute
  ) {
    this._activateRoute.queryParams.subscribe({
      next: (params) => {
        const { sortBy, orderBy, } = params;
        this.findSortBy(sortBy, orderBy);
      },
    });
  }

  ngOnInit(): void {
    if (!this.sortOptions.length) {
      this.getSortOptions();
    }
  }

  findSortBy(sortBy: string, orderBy: string) {
    const sortOption = this.sortOptions
      .find((option: SortOption) => option.key == sortBy && option.value == orderBy);
    if (sortOption) this.sortByLabel = sortOption.label;
    else this.sortByLabel = this.sortOptions[AppConstants.ZERO]?.label;
  }

  getSortOptions() {
    this._filterService.getSortOptions().subscribe({
      next: (data: SortOption[]) => {
        this.sortOptions = data;
        const { sortBy, orderBy, } = this._activateRoute.snapshot.queryParams;
        this.findSortBy(sortBy, orderBy);
      },
    });
  }

  toggleSort(sortBy: string) {
    if (sortBy) this.sortByLabel = sortBy;
    this.isOpen = !this.isOpen;
  }
}
